import * as React from "react";
import { Grid } from "@mui/material";
import { applicationPageStyles } from "./applicationPageStyles";
import CustomDataTable from "../../Components/tableComponent/CustomDataTable";
import { useDashboardInfo } from "../../Context/dashboardContext";
import { InsightsHeader } from "./components/insightsHeader/insightsHeader.index";
import { useInsights } from "../../Context/insightContext";
import { useInsightsUtils } from "../../hooks/useInsightsUtils";
import { columnNameToExcludeInUI } from "../../constants/InsightPageColumnsInfo";

const InsightsPage = () => {

    const {
        mainBlock,
        tableCtn,
    } = applicationPageStyles().classes;

    const {
        applicationListRows,
    } = useDashboardInfo();

    const {
        applicationListColumns,
        searchText,
        visibleColumns,
        setVisibleColumns,
        page,
        rowsPerPage,
        setRowsPerPage,
        tableBodyRef,
        totalRowCount,
    } = useInsights();

    const {
        HandleChangePage,
        HandleRowPerPageChange,
        OnSearchHandler,
    } = useInsightsUtils()

    return (
        <Grid
            container
            direction="column"
            className={mainBlock}
        >
            <InsightsHeader
                onSearch={OnSearchHandler}
                searchValue={searchText}
                totalTableInfo={
                    applicationListColumns !== null ?
                        applicationListColumns
                            .filter(val => !columnNameToExcludeInUI.includes(val.key))
                            .map((v) => v.key) : []}
                visibleColumns={visibleColumns}
                setVisibleColumns={setVisibleColumns}
            />
            <Grid
                item
                className={tableCtn}
            >
                {applicationListColumns !== null && applicationListRows !== null && (
                    <CustomDataTable
                        rows={applicationListRows}
                        columns={applicationListColumns}
                        totalRowsCount={totalRowCount}
                        pageNo={page}
                        handleChangePage={HandleChangePage}
                        rowsPerPage={rowsPerPage}
                        setRowsPerPage={setRowsPerPage}
                        handleRowPerPageChange={HandleRowPerPageChange}
                        tableBodyRef={tableBodyRef}
                        visibleColumns={visibleColumns}
                    />
                )}
            </Grid>
        </Grid>
    );
};

export default InsightsPage;